import { BottomFillIcon, CheckedFillIcon, ConfirmFillIcon, CrossIcon, RoundIcon } from "@t8891/icon";
import { Button, Popup } from "@t8891/mobile";
import { useSetState } from "ahooks";
import React, { useEffect, useRef } from "react";
import { collectDefaultItems, itemIdValueEqual, mergeUnique } from "utils/InquiryLogistics";
// import Image from "next/image";
function handleSelection(arr: any, inputItem: any) {
  // 深拷贝数组避免污染原数据
  let newArr = [...arr];
  const inputGroup = inputItem.group;

  // 条件1：存在相同value则移除，否则添加
  const existingIndex = newArr.findIndex((item) => item.value === inputItem.value);
  if (existingIndex > -1) {
    newArr.splice(existingIndex, 1);
  } else {
    newArr.push(inputItem);
  }

  // 条件2：移除不同group的项
  newArr = newArr.filter((item) => item.group === inputGroup);

  return newArr;
}

const List: React.FC<any> = ({ temporaryArr, options, onChange, itemId }: any) => {
  return (
    <div className='mt-16'>
      <div className='grid gap-14'>
        {options.map((item: any, index: number) => (
          <div
            className='flex-wrap gap-8 items-center'
            key={index}
            onClick={() => {
              onChange(item);
            }}
          >
            <div className='flex gap-8 items-center cursor-pointer'>
              <div className='flex items-center'>
                {itemIdValueEqual({ formParams: temporaryArr, itemId: itemId, value: item.value }) ? (
                  <div className='relative w-18 h-18 -mt-2'>
                    <img
                      className='w-full'
                      src={`https://photo.8891.com.tw/2025/03/24/1742802431435186.png`}
                      alt={""}
                    />
                  </div>
                ) : (
                  <div className='relative w-18 h-18 -mt-2'>
                    <img
                      className='w-full'
                      src={`https://photo.8891.com.tw/2025/03/24/1742802422879910.png`}
                      alt={""}
                    />
                  </div>
                )}
              </div>
              <div
                className={`text-16 ${
                  itemIdValueEqual({ formParams: temporaryArr, itemId: itemId, value: item.value })
                    ? "text-[#3264FF]"
                    : "text-[#333]"
                }`}
              >
                {item.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const CheckBoxSelect: React.FC<any> = ({ item, formParams, onChange, parentItemId }) => {
  const { title, options, itemId, required } = item;
  const [params, setParams] = useSetState<any>({
    visible: false,
    temporaryArr: [],
  });
  const { temporaryArr } = params;

  useEffect(() => {
    if (formParams?.length) {
      const resultItems = collectDefaultItems([item]);

      let result = formParams.filter((item: any) => item.itemId === itemId);

      const mergedArray = mergeUnique(resultItems, result);

      setParams({ arr: mergedArray });
      setParams({ temporaryArr: mergedArray });
    }
  }, []);

  return (
    <>
      <div id='multi-select-popup'>
        <div className={`${parentItemId === item.itemId ? "text-16 font-[600]" : "text-14"} flex  mb-16`}>
          {!!required && (
            <div className='flex items-center'>
              <div className='text-[#FF0000] text-16 h-10'>*</div>
            </div>
          )}
          {title}
        </div>
        <List
          temporaryArr={temporaryArr}
          options={options}
          itemId={itemId}
          onChange={(val: any) => {
            val.parentItemId = parentItemId;
            val.itemId = itemId;
            val.type = "multi-select";
            let result = handleSelection(temporaryArr, val);
            setParams({
              temporaryArr: result,
            });
            onChange(result, "multi-select");
          }}
        />
      </div>
    </>
  );
};
export default CheckBoxSelect;
